import { render } from "./WidthMonitor.vue?vue&type=template&id=2e2b39b2"
import script from "./WidthMonitor.vue?vue&type=script&lang=js"
export * from "./WidthMonitor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__